import QRCode from "react-qr-code";
import { appAsset } from "../../../app.asset";
import "./transaction-qr.scss";
export interface TransactionQrModel {
  transactionCode: string;
  code: string;
  name: string;
  isParent: boolean;
}
export interface TransactionQrProps {
  model: TransactionQrModel;
}

export function TransactionQr({ model }: TransactionQrProps) {
  const qrValue = model.isParent
    ? `${model.transactionCode}:parent:${model.code}`
    : `${model.transactionCode}:child:${model.code}`;
    
  return (
    <div id="TransactionQr" className="transaction-qr">
      <style type="text/css" media="print">
        {
          "\
      @page { size: 2.83in 4.02in; }\
    "
        }
      </style>
      <section className=" flex justify-center items-center flex-col gap-4 h-screen">
        <img
          src={appAsset.logo}
          alt="Client Logo"
          className="w-32 h-32 mx-auto print:w-20 print:h-20"
        />
        <QRCode value={qrValue} size={150} />
        <section className="flex flex-col items-center justify-center">
          <div className="flex flex-col items-center font-bold">
            {model.name}
          </div>
          <div>{model.isParent ? "Parent" : "Child"}</div>
        </section>
      </section>
    </div>
  );
}

export default TransactionQr;
